import updateChildrenPresence from './update-children-presence';
import findBlockSettingComments from './find-block-setting-comments';
import updateBlockId from './update-block-id';
import getClosestSelectableElement from './get-closest-selectable-element';
import generateIdSuffix from './generate-id-suffix';
import webkitWorkarounds from './webkit-workarounds';
import WSInternalEvent from './ws-internal-event';

import preserveTextElement from './preserve-text-element';

export default {
  updateChildrenPresence,
  findBlockSettingComments,
  updateBlockId,
  getClosestSelectableElement,
  generateIdSuffix,
  WSInternalEvent,
  webkitWorkarounds,
  preserveTextElement,
};
